
import React from "react";

import APPCONFIG from "../../../../../constants/Config";
import Framework from "@beardeddevops/react.framework";

import {Collections, Objects} from "components";
import {Tab,Tabs} from "@material-ui/core";
import {Button} from "reactstrap";

const {UniversalModal} = Framework.Elements;
const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/dashboard',
		icon: 'dashboard',
	},
	{
		name: 'Registers',
		url: '/registers',
		icon: 'usd',
	}
];

class Register extends Framework.Components.View {

	constructor(props) {
		super(props,'details');
		this.state.current_amount =0;
		this.state.method = '';
		this.state.ledgerName ='';
		this.state.key = 0;
		this.state.pendingMethod = null;
		this.state.countResult = null;
		this.state.modalCount = false;
		this.state.modalLedger = false;
		this.setCurrentAmount = this.setCurrentAmount.bind(this);

	}

	setCurrentAmount(amount) {
		this.setState({current_amount:amount})
	}

	handleAfterSave = () => {
		this.setState({
			modalCount: false,
			modalLedger: false,
			refresh: !this.state.refresh,
			key: Math.random(),
			countResult: null,
			pendingMethod: null,
			method: '',
		});
	}

	closeCountModal = () => {
		this.setState({
			modalCount: false,
			pendingMethod: null,
			countResult: null,
		});
	}

	closeLedgerModal = () => {
		this.setState({
			modalLedger: false,
			countResult: null,
			pendingMethod: null,
			method: '',
		});
	}

	handleCountAfterSave = () => {
		this.setState({
			modalCount: false,
			pendingMethod: null,
			refresh: !this.state.refresh,
			key: Math.random(),
		});
	}

	handleCountComplete = (countResult, pendingMethod) => {
		const ledgerName = pendingMethod === 'eod' ? 'End of Day' : 'Start of Day';
		this.setState({
			countResult,
			pendingMethod,
			method: pendingMethod,
			ledgerName,
			modalCount: false,
			modalLedger: true,
		});
	}

	toggleLedger=(event)=>{
		switch (event.currentTarget.id){
			case 'count':
				this.setState({
					pendingMethod: null,
					countResult: null,
					method: '',
					ledgerName: 'Count',
					modalLedger: false,
					modalCount: true,
				});
				return;
			case 'sod':
				this.setState({
					pendingMethod: 'sod',
					countResult: null,
					method: '',
					ledgerName: 'Start of Day',
					modalLedger: false,
					modalCount: true,
				});
				return;
			case 'adj':
				this.setState({
					pendingMethod: null,
					countResult: null,
					method: 'adj',
					ledgerName: 'Adjustment',
					modalCount: false,
					modalLedger: true,
				});
				return;
			case 'eod':
				this.setState({
					pendingMethod: 'eod',
					countResult: null,
					method: '',
					ledgerName: 'End of Day',
					modalLedger: false,
					modalCount: true,
				});
				return;
		}
	}

	registerObjectProps = () => ({
		currentAmount: this.state.current_amount,
		method: this.state.method,
		registerAuditDenominations: this.props.rootState?.register_audit_denominations,
		registerRequireVarianceNote: this.props.rootState?.register_require_variance_note,
		retainedFloat: this.props.rootState?.retained_float,
		registerDefaultDenominations: this.props.rootState?.register_default_denominations,
		countResult: this.state.countResult,
		lockedFromCount: !!(this.state.countResult && (this.state.method === 'sod' || this.state.method === 'eod')),
	});

	countObjectProps = () => ({
		currentAmount: this.state.current_amount,
		registerAuditDenominations: this.props.rootState?.register_audit_denominations,
		registerRequireVarianceNote: this.props.rootState?.register_require_variance_note,
		registerDefaultDenominations: this.props.rootState?.register_default_denominations,
		retainedFloat: this.props.rootState?.retained_float,
		preflightMethod: this.state.pendingMethod,
		onCountComplete: this.handleCountComplete,
	});

	render() {
		const  {tab} = this.state;
		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: this.state.name,
				url: `/registers/${this.props.id}`,
				icon: 'edit',
			}
		]);
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}>
					<Button id ='count' color="info" style={{marginRight:"5px"}} onClick={this.toggleLedger}>Count</Button>
					<Button id ='sod' className="primary-button" style={{marginRight:"5px"}} onClick={this.toggleLedger}>Start of Day</Button>
					<Button id ='adj' className="secondary-button" style={{marginRight:"5px"}} onClick={this.toggleLedger}>Adjust</Button>
					<Button id ='eod' className="primary-button"  onClick={this.toggleLedger}>End of Day</Button>
				</Framework.Components.PageBar>

				<Tabs value={tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Register" value="details"/>
					<Tab label="Ledger" value="ledger"/>
				</Tabs>

				<div style={{display: tab === 'details' ? 'block' : 'none'}}>
				 <Framework.Errors.General isDev={APPCONFIG.settings.isDev()}>

					<Objects.Register
						history={this.props.history}
						base={this.props.base}
						id={this.props.match.params.id}
						shouldSave={this.state["saveModelRegister"]}
						shouldDelete={this.state["deleteModelRegister"]}
						reloadSelf={this.state.refresh}
						setCurrentAmount={this.setCurrentAmount}
						baseUrl={this.props.baseUrl}
					/>
				</Framework.Errors.General>


				</div>

				<div style={{display: tab === 'ledger' ? 'block' : 'none'}}>
					<Framework.Errors.General isDev={APPCONFIG.settings.isDev()}>
						<Collections.RegisterLedgers
							key={this.state.key}
							account={this.props.account}
							parent={this.props.match.params.id}
							history={this.props.history}
							reloadParent={this.props.reloadParent}
							reloadSelf={this.state.refresh}
						/>
					</Framework.Errors.General>
				</div>

				<UniversalModal
					parent={this.props.match.params.id}
					isDev={APPCONFIG.settings.isDev()}
					locations={this.props.locations}
					name={'Count'}
					object={Objects.RegisterLedgerCount}
					history={this.props.history}
					toggle={this.state.modalCount}
					showModal={this.state.modalCount}
					reportClose={this.closeCountModal}
					afterSave={this.handleCountAfterSave}
					submitLabel={this.state.pendingMethod ? 'Continue' : 'Submit Count'}
					size={'lg'}
					objectProps={this.countObjectProps()}
					project={'pos'}
				/>

				<UniversalModal
					parent={this.props.match.params.id}
					isDev={APPCONFIG.settings.isDev()}
					locations={this.props.locations}
					name={'Ledger'}
					object={Objects.RegisterLedger}
					history={this.props.history}
					toggle={this.state.modalLedger}
					showModal={this.state.modalLedger}
					reportClose={this.closeLedgerModal}
					afterSave={this.handleAfterSave}
					submitLabel={`Submit ${this.state.ledgerName}`}
					size={'lg'}
					objectProps={this.registerObjectProps()}
					project={'pos'}
				/>


			</div>
		)
	}
};

export default Framework.Components.withRootState(Register);
